module.exports = __webpack_public_path__ + "img/2f8a60915b923f8be7c510a322f8f534.5c83a93f.jpg";